import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardFooter,
  Media,
  Button,
} from 'reactstrap';
import Loader from 'react-loader-spinner';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import Can from '../../components/Can';
import TezosLogo from '../../components/Common/TezosLogo.js';
import EthereumLogo from '../../components/Common/EthereumLogo.js';
import {
  registrationDetails,
  acceptCompany,
  rejectCompany,
} from '../../helpers/api';

class RegistrationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      laoding: true,
      company: {},
      processing: false,
    };
  }

  loadRegistration = async () => {
    this.setState({ loading: true });
    const res = await registrationDetails(this.props.match.params.id);
    this.setState({ company: res.company, loading: false });
  };

  componentDidMount = () => {
    this.loadRegistration();
  };

  openLink = (link, title, pdf) => {
    var newWindow = window.open();
    let html = `<html><head><title>${title}</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head><body>`;
    if (pdf) {
      html += `<embed width="100%" height="100%" src="${link}" type="application/pdf" />`;
    } else
      html += `<img src="${link}" style={max-width: 100vw; max-height: 100vh}/>`;
    html += '</body>';
    html += '</html>';
    setTimeout(() => {
      newWindow.document.write(html);
    }, 0);
  };

  accept = async () => {
    if (
      window.confirm(
        `Accept & validate ${this.state.company.companyName} as new client ?`,
      )
    ) {
      this.setState({ processing: true });
      await acceptCompany(this.state.company.id);
      window.location.reload();
    }
  };

  reject = async () => {
    if (
      window.confirm(`Reject ${this.state.company.companyName} as new client ?`)
    ) {
      this.setState({ processing: true });
      await rejectCompany(this.state.company.id);
      window.location.reload();
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.state.loading ? (
              <Loader type="Puff" color="#545454" height={50} width={50} />
            ) : (
              <Row>
                <Col xl="6">
                  <Card className="overflow-hidden">
                    <CardBody className="pt-2">
                      <Row>
                        <Col sm="12">
                          {this.state.company.status === 'REJECTED' ? (
                            <span className="badge badge-danger font-size-12">
                              Rejected
                            </span>
                          ) : this.state.company.status === 'VALIDATED' ? (
                            <span className="badge badge-success font-size-12">
                              Approved
                            </span>
                          ) : (
                            <span className="badge badge-warning font-size-12 float-right">
                              Pending
                            </span>
                          )}
                          <h3 className="text-truncate mt-4 p-relative">
                            {this.state.company.companyName}
                          </h3>
                          <p className="text-muted mb-2 text-truncate p-relative font-size-11">
                            Registered on{' '}
                            {new Date(
                              this.state.company.createdAt,
                            ).toLocaleDateString()}
                          </p>
                          <hr />
                          <p className="text-muted mb-2 text-truncate p-relative">
                            Purpose:{' '}
                            <strong>{this.state.company.purpose}</strong>
                          </p>
                          <p className="text-muted mb-2 text-truncate p-relative">
                            Token usage:{' '}
                            <strong>{this.state.company.tokenUse}</strong>
                          </p>
                          <p className="text-muted mb-2 text-truncate p-relative">
                            Expected volume:{' '}
                            <strong>
                              {this.state.company.expectedVolume}{' '}
                              <small>EUROP</small>
                            </strong>
                          </p>
                          <hr />
                          <p className="text-muted mb-2 text-truncate p-relative">
                            Business sector: {this.state.company.businessSector}
                          </p>
                          <p className="text-muted mb-0 text-truncate p-relative">
                            Full address: {this.state.company.fullAddress}
                          </p>
                        </Col>
                        {/* <Col sm="12">
                          <div className="pt-4">
                            <Row>
                              <Col xs="12">
                                <h5 className="font-size-15">Bank</h5>
                                <p className="text-muted mb-0 font-size-12 p-relative">
                                  IBAN: {this.state.company.iban}
                                  <br/>
                                  BIC: {this.state.company.bic}
                                </p>
                              </Col>
                            </Row>
                          </div>
                        </Col> */}
                        <Col sm="12">
                          <div className="pt-4">
                            <Row>
                              <Col xs="12">
                                <h5 className="font-size-15">Contact email</h5>
                                <p className="text-muted mb-0 font-size-12 p-relative">
                                  {this.state.company.contactMail}
                                </p>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    {this.state.company.status === 'PENDING' && (
                      <Can
                        role={this.props.user.role}
                        perform="operator:financial"
                        yes={() => {
                          return this.state.processing ? (
                            <CardFooter>
                              <Loader
                                type="Puff"
                                color="#50a5f1"
                                height={20}
                                width={20}
                              />
                              <p className="mt-2 text-info">
                                Notification sent onto your TrustBuilder
                                Authenticator application.{' '}
                                <strong>
                                  Set your pin code to complete operation...
                                </strong>
                              </p>
                            </CardFooter>
                          ) : (
                            <CardFooter>
                              <Row>
                                <Col sm="6">
                                  <Button color="success" onClick={this.accept}>
                                    Accept application
                                  </Button>
                                </Col>
                                <Col sm="6">
                                  <Button color="danger" onClick={this.reject}>
                                    Reject application
                                  </Button>
                                </Col>
                              </Row>
                              <Row>
                                <Col sm="12">
                                  <p className="mt-2">
                                    Note that acceptance will not create client
                                    reference. You will have to reference it{' '}
                                    <a href="/new-client" className="text-info">
                                      here
                                    </a>.
                                  </p>
                                </Col>
                              </Row>
                            </CardFooter>
                          );
                        }}
                      />
                    )}
                  </Card>
                  {this.state.company.tezosPkh && (
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <p className="text-muted font-weight-medium">
                              Tezos FA2 Wallet
                              <br />
                              <small>{this.state.company.tezosPkh}</small>
                            </p>
                          </Media>
                          <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                            <span
                              className="avatar-title"
                              style={{ paddingLeft: '6px' }}
                            >
                              <TezosLogo width="20" height="20" />
                            </span>
                          </div>
                        </Media>
                      </CardBody>
                    </Card>
                  )}
                  {this.state.company.ethPkh && (
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <p className="text-muted font-weight-medium">
                              ERC20 Wallet
                              <br />
                              <small>{this.state.company.ethPkh}</small>
                            </p>
                          </Media>
                          <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                            <span
                              className="avatar-title"
                              style={{ paddingLeft: '6px' }}
                            >
                              <EthereumLogo width="20" height="20" />
                            </span>
                          </div>
                        </Media>
                      </CardBody>
                    </Card>
                  )}
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { user } = state.Login;
  return { user };
};

export default withRouter(
  connect(mapStatetoProps, null)(withTranslation()(RegistrationDetails)),
);
